'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, cn } from '@heroui/react';
import { useMemo } from 'react';
import type { ConfirmModalProps } from './interfaces';
export default function ConfirmModal(t0) {
  const $ = _c(51);
  let inputValue;
  let isOpen;
  let onCancel;
  let onClose;
  let onConfirm;
  let onOpenChange;
  let rest;
  let setInputValue;
  let t1;
  if ($[0] !== t0) {
    ({
      isOpen,
      onOpenChange,
      onClose,
      config: t1,
      onConfirm,
      onCancel,
      inputValue,
      setInputValue,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = inputValue;
    $[2] = isOpen;
    $[3] = onCancel;
    $[4] = onClose;
    $[5] = onConfirm;
    $[6] = onOpenChange;
    $[7] = rest;
    $[8] = setInputValue;
    $[9] = t1;
  } else {
    inputValue = $[1];
    isOpen = $[2];
    onCancel = $[3];
    onClose = $[4];
    onConfirm = $[5];
    onOpenChange = $[6];
    rest = $[7];
    setInputValue = $[8];
    t1 = $[9];
  }
  const {
    title,
    description,
    cancelButtonProps,
    confirmButtonProps,
    confirmText: t2,
    cancelText: t3,
    icon,
    customActions,
    requireConfirmationText: t4,
    compareTo: t5,
    confirmationTextInputProps
  } = t1;
  const confirmText = t2 === undefined ? "Confirmar" : t2;
  const cancelText = t3 === undefined ? "Cancelar" : t3;
  const requireConfirmationText = t4 === undefined ? false : t4;
  const compareTo = t5 === undefined ? "" : t5;
  let t6;
  if ($[10] !== compareTo || $[11] !== inputValue || $[12] !== requireConfirmationText) {
    t6 = !requireConfirmationText || inputValue?.trim() === compareTo?.trim();
    $[10] = compareTo;
    $[11] = inputValue;
    $[12] = requireConfirmationText;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const isInputValid = t6;
  const t7 = icon && icon;
  let t8;
  if ($[14] !== title) {
    t8 = <h1 className="text-lg">{title}</h1>;
    $[14] = title;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = description && description;
  let t10;
  if ($[16] !== t9) {
    t10 = <p className="text-default-600 text-base font-normal text-pretty text-ellipsis">{t9}</p>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7 || $[20] !== t8) {
    t11 = <ModalHeader className="flex flex-col gap-2">{t7}{t8}{t10}</ModalHeader>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== compareTo || $[23] !== confirmationTextInputProps || $[24] !== inputValue || $[25] !== requireConfirmationText || $[26] !== setInputValue) {
    t12 = requireConfirmationText && <Input label={confirmationTextInputProps?.label || <p className="text-sm font-medium">Por favor, digite <strong className="text-danger-500">{compareTo}</strong> para confirmar</p>} classNames={{
      label: cn("flex flex-wrap", confirmationTextInputProps?.classNames?.label)
    }} labelPlacement="outside" type="text" size="lg" value={inputValue} onChange={e => setInputValue?.(e.target.value)} placeholder={confirmationTextInputProps?.placeholder || "Digite aqui..."} isRequired={true} isClearable={true} onClear={() => setInputValue?.("")} variant="bordered" {...confirmationTextInputProps} />;
    $[22] = compareTo;
    $[23] = confirmationTextInputProps;
    $[24] = inputValue;
    $[25] = requireConfirmationText;
    $[26] = setInputValue;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12) {
    t13 = <ModalBody>{t12}</ModalBody>;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== cancelButtonProps || $[31] !== cancelText || $[32] !== confirmButtonProps || $[33] !== confirmText || $[34] !== customActions || $[35] !== isInputValid || $[36] !== onCancel || $[37] !== onConfirm) {
    t14 = customActions ? customActions(onConfirm, onCancel) : <><Button variant="shadow" color="danger" onPress={onCancel} {...cancelButtonProps}>{cancelText}</Button><Button variant="shadow" color="primary" onPress={onConfirm} {...confirmButtonProps} isDisabled={!isInputValid}>{confirmText}</Button></>;
    $[30] = cancelButtonProps;
    $[31] = cancelText;
    $[32] = confirmButtonProps;
    $[33] = confirmText;
    $[34] = customActions;
    $[35] = isInputValid;
    $[36] = onCancel;
    $[37] = onConfirm;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== t14) {
    t15 = <ModalFooter>{t14}</ModalFooter>;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t11 || $[42] !== t13 || $[43] !== t15) {
    t16 = <ModalContent>{t11}{t13}{t15}</ModalContent>;
    $[41] = t11;
    $[42] = t13;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== isOpen || $[46] !== onClose || $[47] !== onOpenChange || $[48] !== rest || $[49] !== t16) {
    t17 = <Modal backdrop="blur" size="lg" isOpen={isOpen} onOpenChange={onOpenChange} onClose={onClose} isDismissable={false} isKeyboardDismissDisabled={true} hideCloseButton={true} {...rest}>{t16}</Modal>;
    $[45] = isOpen;
    $[46] = onClose;
    $[47] = onOpenChange;
    $[48] = rest;
    $[49] = t16;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  return t17;
}